import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/theMidAutumnFestival/2026/Index.vue')
const LotteryRewards = () => import('../activity/theMidAutumnFestival/2026/LotteryRewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/the-mid-autumn-festival/2026',
  name: 'activity_the_mid_autumn_festival_2026',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '中秋月饼铺',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/the-mid-autumn-festival/2026/lottery-rewards',
  name: 'activity_the_mid_autumn_festival_2026_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export default [indexRoute, lotteryRewardsRoute]
